<div class="_dialog-title">
  <div class="flex-grow-1">{{offerGroup.title}}</div>
  <button mat-mini-fab mat-dialog-close color="accent">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="_dialog-content">

  <div class="" style="padding: 0.5rem 1rem; font-size: 16px; font-weight: 600; font-style:italic; text-align:center; ">{{offerGroup.description}}</div>

  <div class="offers-menu-cat" style="border-bottom-width: 0;">
    <menu-offers-container class="">
      @for (offer of offerGroup.offers; track offer) {
        <div class="menu-offer"
          [id]="'boffer_' + offer._id"
          (mousedown)="selectOffer(offer, $event)"
          [ngClass]="{'_active':$storage.order.offerCounters[offer.offer], '_folder':offer.type == 'folder', '_disabled': offer.stockDisabled}">
          <div class="menu-offer-body">
            <div class="_body">
              <div class="menu-offer-title">{{offer.name}}</div>
              @if (offer.description_display != 'hide') {
                <div class="menu-offer-description">{{offer.description}}</div>
              }
              <div class="menu-offer-price">
                @if (offer.price > 0) {
                  <div class="_price">{{offer.price | lcurrency}}</div>
                } @else {
                  <div class="_price"></div>
                }
                <app-offer-attributes [offer]="offer"></app-offer-attributes>
              </div>
            </div>
            <!--[class.no-image]="offer.iconImage" [appBgImage]="offer.imageURL" [model]="cat"-->
            <div class="_image" [ngStyle]="offer.catStyle || offer.cardStyle" [class.stock-disabled]="offer.stockDisabled">
              <img [appImageSrc]="offer.imageURL" [model]="offer" loading="lazy" />
              <app-offer-marketing [offer]="offer" [$storage]="$storage"></app-offer-marketing>
            </div>
          </div>
        </div>
      }
    </menu-offers-container>
  </div>
</div>

@if (!hideNext) {
  <div class="_bottom-actions border-top">
    @if (hasCancel) {
      <button type="button" mat-button class="_cancel" (mousedown)="closeApplyDialog(null)">
        {{'Cancel' | translate}}
      </button>
    }
    @if (!hasCancel) {
      @if (!hasNext) {
        <button type="button" mat-button class="_cancel" (mousedown)="closeApplyDialog(null)">
          {{nextCaption | translate}}
        </button>
      }
      @if (hasNext) {
        <button type="submit" mat-flat-button color="accent" class="rounded" (mousedown)="closeApplyDialog()">{{nextCaption | translate}}</button>
      }
    }
  </div>
}

